import { TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import {
  IPortfoPairPositionTableReport,
  IPortfoPairPositionUser,
} from "../../../Interfaces/deltaHedgeAccounts";
import { IStepOptionDropdownItem, StepOptionOrderType, StepOrderSide } from "../../../Interfaces/stepInterfaces";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import CompactOrderPreviewTable from "../../../Components/CompactOrderPreviewTable";
import OrderPreviewInstrument, { PreviewInstrumentHeader } from "../../../Components/OrderPreviewInstrument";
import { getStepInstruments } from "../../../Requests/stepRequests";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { addSeperatorToInput } from "../../../helper";

interface IProps {
  row: IPortfoPairPositionTableReport;
  users: IPortfoPairPositionUser[];
  maxPairPosition: string;
}

const NLegOrderPreviewTable = ({ row, users, maxPairPosition }: IProps) => {
  const [instruments, setInstruments] = useState<IStepOptionDropdownItem[]>([]);
  useEffect(() => {
    getStepInstruments().then(setInstruments).catch(packetErrorHandler);
  }, []);
  const firstInstrument = instruments.find(instrument => String(instrument.id) === String(row.instrumentId1));
  const secondInstrument = instruments.find(instrument => String(instrument.id) === String(row.instrumentId2));
  // This preview closes existing positions, so each order has the opposite side.
  const firstSide = row.orderSide1Enum === StepOrderSide.Buy ? StepOrderSide.Sell : StepOrderSide.Buy;
  const secondSide = row.orderSide2Enum === StepOrderSide.Buy ? StepOrderSide.Sell : StepOrderSide.Buy;

  const getHeader = () => (
    <>
      <TableCell>اکانت</TableCell>
      <TableCell>نسبت</TableCell>
      <TableCell
        className={
          row.orderSide1Enum === StepOrderSide.Buy
            ? "!text-red-700"
            : row.orderSide1Enum === StepOrderSide.Sell
            ? "!text-green-600"
            : "!text-gray-600"
        }
      >
        <PreviewInstrumentHeader>نماد اول</PreviewInstrumentHeader>
      </TableCell>
      <TableCell
        className={
          row.orderSide1Enum === StepOrderSide.Buy
            ? "!text-red-700"
            : row.orderSide1Enum === StepOrderSide.Sell
            ? "!text-green-600"
            : "!text-gray-600"
        }
      >
        حجم اول
      </TableCell>
      <TableCell
        className={
          row.orderSide2Enum === StepOrderSide.Buy
            ? "!text-red-700"
            : row.orderSide2Enum === StepOrderSide.Sell
            ? "!text-green-600"
            : "!text-gray-600"
        }
      >
        <PreviewInstrumentHeader>نماد دوم</PreviewInstrumentHeader>
      </TableCell>
      <TableCell
        className={
          row.orderSide2Enum === StepOrderSide.Buy
            ? "!text-red-700"
            : row.orderSide2Enum === StepOrderSide.Sell
            ? "!text-green-600"
            : "!text-gray-600"
        }
      >
        حجم دوم
      </TableCell>

      <TableCell>حداکثر بهای<br />تمام شده</TableCell>
    </>
  );

  const doNothing = () => {};

  const getBody = () => (
    <>
      {users.map((u) => (
        <TableRow>
          <TableCell>
            <StaticDropdown
              options={users.map((u) => ({ id: u.userId, name: u.userName }))}
              dropdown={{
                name: "",
                placeholder: "",
                disabled: true,
              }}
              onChange={doNothing}
              value={u.userId}
            />
          </TableCell>

          <TableCell>
            <div className="flex flex-row justify-start items-center">
              <div
                className={`${
                  row.orderSide1Enum === StepOrderSide.Buy
                    ? "text-red-700"
                    : row.orderSide1Enum === StepOrderSide.Sell
                    ? "!text-green-600"
                    : "text-gray-600"
                }`}
              >
                {row.offsetHedgeFactor}
              </div>
              <div>-</div>
              <div
                className={`${
                  row.orderSide2Enum === StepOrderSide.Buy
                    ? "text-red-700"
                    : row.orderSide2Enum === StepOrderSide.Sell
                    ? "text-green-600"
                    : "text-gray-600"
                }`}
              >
                1
              </div>
            </div>
          </TableCell>

          <TableCell>
            <OrderPreviewInstrument name={row.instrumentName1} orderSide={firstSide} optionOrderType={StepOptionOrderType.Offset} instrumentType={firstInstrument?.type} />
          </TableCell>
          <TableCell>
            {Math.abs(
              users.find((user) => user.userId === u.userId)?.relatedPortfo
                .instrumentVolume1 || 0
            ) || "-"}
          </TableCell>
          <TableCell>
            <OrderPreviewInstrument name={row.instrumentName2} orderSide={secondSide} optionOrderType={StepOptionOrderType.Offset} instrumentType={secondInstrument?.type} />
          </TableCell>
          <TableCell>
            {Math.abs(
              users.find((user) => user.userId === u.userId)?.relatedPortfo
                .instrumentVolume2 || 0
            ) || "-"}
          </TableCell>

          <TableCell className="ltr">
            {addSeperatorToInput(maxPairPosition, "priceWithDecimal")}
          </TableCell>
        </TableRow>
      ))}{" "}
    </>
  );

  return <CompactOrderPreviewTable header={getHeader()} body={getBody()} />;
};

export default NLegOrderPreviewTable;
